module.exports = __webpack_public_path__ + "img/magnum-super.9c40920b.svg";